// import React, { useState, useEffect } from "react";
// import { Container, Form, Button, Table, Alert } from "react-bootstrap";
// import NavigationBar from "../../Components/NavigationBar";
// import axios from "axios";
// import "./AwardApplications.css";

// const AwardApplications = () => {
//   const [awardType, setAwardType] = useState("");
//   const [file, setFile] = useState(null);
//   const [templates, setTemplates] = useState([]);
//   const [message, setMessage] = useState("");
//   const [awardOptions, setAwardOptions] = useState([]);
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
//   const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/getAwards`)
//       .then((response) => {
//         setAwardOptions(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching awards:", error);
//       });

//     axios
//       .get(`${API_BASE_URL}/getTemplates`) // Correct endpoint
//       .then((response) => {
//         setTemplates(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching templates:", error);
//       });
//   }, []);

//   const handleDownload = (filePath) => {
//     window.open(`${FILE_BASE_URL}/${filePath}`, "_blank");
//   };

//   const handleFileChange = (e) => {
//     setFile(e.target.files[0]);
//   };

//   const handleUpload = async (e) => {
//     e.preventDefault();

//     if (!awardType || !file) {
//       setMessage("Please select an award type and upload a file.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("awardType", awardType);

//     try {
//       const response = await axios.post(
//         `${API_BASE_URL}/uploadTemplate`,
//         formData,
//         {
//           headers: { "Content-Type": "multipart/form-data" },
//         }
//       );

//       setMessage(response.data.message);
//       setFile(null);
//       setAwardType("");

//       // Refresh template list
//       axios.get(`${API_BASE_URL}/getTemplates`).then((res) => {
//         setTemplates(res.data);
//       });
//     } catch (error) {
//       console.error("Upload error:", error);
//       setMessage("File upload failed.");
//     }
//   };

//   // const handleDownload = (filePath) => {
//   //   window.open(`http://localhost:5000/download-template?file=${filePath}`, "_blank");
//   // };

//   return (
//     <div>
//       <NavigationBar />
//       <h2 className="awardapplication-title">Manage Award Templates</h2>
//       <Container className="mt-4">
//         {message && <Alert variant="info">{message}</Alert>}

//         <Form onSubmit={handleUpload}>
//           <Form.Group controlId="awardType" className="mt-3">
//             <Form.Label>Select Award Type:</Form.Label>
//             <Form.Control
//               as="select"
//               value={awardType}
//               onChange={(e) => setAwardType(e.target.value)}
//             >
//               <option value="">Choose...</option>
//               {awardOptions.length > 0 ? (
//                 awardOptions.map((award) => (
//                   <option key={award.Award_Id} value={award.Award_Id}>
//                     {award.Name}
//                   </option>
//                 ))
//               ) : (
//                 <option>No award types available</option>
//               )}
//             </Form.Control>
//           </Form.Group>

//           <Form.Group controlId="formFile" className="mt-3">
//             <Form.Label>Upload Application Template:</Form.Label>
//             <Form.Control type="file" onChange={handleFileChange} />
//           </Form.Group>

//           <Button
//             variant="primary"
//             type="submit"
//             className="upload-btn-directorapplication"
//           >
//             Upload Template
//           </Button>
//         </Form>
//       </Container>

//       <h3 className="mt-5">Uploaded Templates</h3>
//       {templates.length > 0 ? (
//         <Table striped bordered hover className="application_table">
//           <thead>
//             <tr>
//               <th>Award Type</th>
//               <th>Template File</th>
//               <th>View File</th>
//             </tr>
//           </thead>
//           <tbody>
//             {templates.map((template, index) => (
//               <tr key={index}>
//                 <td>{template.awardName}</td>
//                 <td>{template.filePath}</td>
//                 <td>
//                   <Button
//                     variant="success"
//                     size="sm"
//                     onClick={() => handleDownload(template.filePath)}
//                   >
//                     Download
//                   </Button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       ) : (
//         <p className="p-title">No templates uploaded yet.</p>
//       )}


//        <h2 className="awardapplication-title">Upload Application Criteria Details</h2>
//        <label>Please Upload a PDF Document</label>
//       <Container className="mt-4">
//         {message && <Alert variant="info">{message}</Alert>}

//         <Form onSubmit={handleUpload}>
//           <Form.Group controlId="awardType" className="mt-3">
//             <Form.Label>Select Award Type:</Form.Label>
//             <Form.Control
//               as="select"
//               value={awardType}
//               onChange={(e) => setAwardType(e.target.value)}
//             >
//               <option value="">Choose...</option>
//               {awardOptions.length > 0 ? (
//                 awardOptions.map((award) => (
//                   <option key={award.Award_Id} value={award.Award_Id}>
//                     {award.Name}
//                   </option>
//                 ))
//               ) : (
//                 <option>No award types available</option>
//               )}
//             </Form.Control>
//           </Form.Group>

//           <Form.Group controlId="formFile" className="mt-3">
//             <Form.Label>Upload Application Criteria:</Form.Label>
//             <Form.Control type="file" onChange={handleFileChange} />
//           </Form.Group>

//           <Button
//             variant="primary"
//             type="submit"
//             className="upload-btn-directorapplication"
//           >
//             Upload Template
//           </Button>
//         </Form>
//       </Container>

//       <h3 className="mt-5">Uploaded Criteria Details</h3>
//       {templates.length > 0 ? (
//         <Table striped bordered hover className="application_table">
//           <thead>
//             <tr>
//               <th>Award Type</th>
//               <th>Template File</th>
//               <th>View File</th>
//             </tr>
//           </thead>
//           <tbody>
//             {templates.map((template, index) => (
//               <tr key={index}>
//                 <td>{template.awardName}</td>
//                 <td>{template.filePath}</td>
//                 <td>
//                   <Button
//                     variant="success"
//                     size="sm"
//                     onClick={() => handleDownload(template.filePath)}
//                   >
//                     Download
//                   </Button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       ) : (
//         <p className="p-title">No templates uploaded yet.</p>
//       )}
//     </div>
//   );
// };

// export default AwardApplications;


import React, { useState, useEffect } from "react";
import { Container, Form, Button, Table, Alert } from "react-bootstrap";
import NavigationBar from "../../Components/NavigationBar";
import axios from "axios";
import "./AwardApplications.css";

const AwardApplications = () => {
  const [awardTypeTemplate, setAwardTypeTemplate] = useState("");
  const [awardTypeCriteria, setAwardTypeCriteria] = useState("");
  const [templateFile, setTemplateFile] = useState(null);
  const [criteriaFile, setCriteriaFile] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [criteria, setCriteria] = useState([]);
  const [templateMessage, setTemplateMessage] = useState("");
  const [criteriaMessage, setCriteriaMessage] = useState("");
  const [awardOptions, setAwardOptions] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || 'http://localhost:5000/uploads';

  useEffect(() => {
    // Fetch award options
    axios
      .get(`${API_BASE_URL}/getAwards`)
      .then((response) => {
        setAwardOptions(response.data);
      })
      .catch((error) => {
        console.error("Error fetching awards:", error);
      });

    // Fetch templates
    axios
      .get(`${API_BASE_URL}/getTemplates`)
      .then((response) => {
        setTemplates(response.data);
      })
      .catch((error) => {
        console.error("Error fetching templates:", error);
      });

    // Fetch criteria
    axios
      .get(`${API_BASE_URL}/getCriteria`)
      .then((response) => {
        setCriteria(response.data);
      })
      .catch((error) => {
        console.error("Error fetching criteria:", error);
      });
  }, []);

  // const handleDownload = (filePath, type) => {
  //   window.open(`${FILE_BASE_URL}/${type}/${filePath}`, "_blank");
  // };
//   const handleDownload = (fileName, type) => {
 
//   window.open(`${FILE_BASE_URL}/${type}/${fileName}`, "_blank");
// };
  const handleDownloadCriteria = (filePath1, type) => {
    window.open(`${FILE_BASE_URL}/api/${filePath1}`, "_blank");
  };
  const handleDownload = (filePath) => {
    window.open(`${FILE_BASE_URL}/api/${filePath}`, "_blank");
  };

  const handleTemplateFileChange = (e) => {
    setTemplateFile(e.target.files[0]);
  };

  const handleCriteriaFileChange = (e) => {
    setCriteriaFile(e.target.files[0]);
  };

  const handleTemplateUpload = async (e) => {
    e.preventDefault();

    if (!awardTypeTemplate || !templateFile) {
      setTemplateMessage("Please select an award type and upload a template file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", templateFile);
    formData.append("awardType", awardTypeTemplate);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/uploadTemplate`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      setTemplateMessage(response.data.message);
      setTemplateFile(null);
      setAwardTypeTemplate("");

      // Refresh template list
      axios.get(`${API_BASE_URL}/getTemplates`).then((res) => {
        setTemplates(res.data);
      });
    } catch (error) {
      console.error("Template upload error:", error);
      setTemplateMessage("Template upload failed.");
    }
  };

  const handleCriteriaUpload = async (e) => {
    e.preventDefault();

    if (!awardTypeCriteria || !criteriaFile) {
      setCriteriaMessage("Please select an award type and upload a criteria file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", criteriaFile);
    formData.append("awardType", awardTypeCriteria);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/uploadCriteria`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      setCriteriaMessage(response.data.message);
      setCriteriaFile(null);
      setAwardTypeCriteria("");

      // Refresh criteria list
      axios.get(`${API_BASE_URL}/getCriteria`).then((res) => {
        setCriteria(res.data);
      });
    } catch (error) {
      console.error("Criteria upload error:", error);
      setCriteriaMessage("Criteria upload failed.");
    }
  };

  return (
    <div>
      <NavigationBar />
      <h2 className="awardapplication-title">Manage Award Templates</h2>
       <label className="p-title">Please Upload a PDF Document</label>
      <Container className="mt-4">
        {templateMessage && <Alert variant="info">{templateMessage}</Alert>}

        <Form onSubmit={handleTemplateUpload}>
          <Form.Group controlId="awardTypeTemplate" className="mt-3">
            <Form.Label>Select Award Type:</Form.Label>
            <Form.Control
              as="select"
              value={awardTypeTemplate}
              onChange={(e) => setAwardTypeTemplate(e.target.value)}
            >
              <option value="">Choose...</option>
              {awardOptions.length > 0 ? (
                awardOptions.map((award) => (
                  <option key={award.Award_Id} value={award.Award_Id}>
                    {award.Name}
                  </option>
                ))
              ) : (
                <option>No award types available</option>
              )}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="formTemplateFile" className="mt-3">
            <Form.Label>Upload Application Template:</Form.Label>
            <Form.Control type="file" onChange={handleTemplateFileChange} />
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="upload-btn-directorapplication mt-3"
          >
            Upload Template
          </Button>
        </Form>
      </Container>

      <h3 className="mt-5">Uploaded Templates</h3>
      {templates.length > 0 ? (
        <Table striped bordered hover className="application_table">
          <thead>
            <tr>
              <th>Award Type</th>
              <th>Template File</th>
              <th>View File</th>
            </tr>
          </thead>
          <tbody>
            {templates.map((template, index) => (
              <tr key={index}>
                <td>{template.awardName}</td>
                <td>{template.filePath}</td>
                <td>
                  <Button
                    variant="success"
                    size="sm"
                    onClick={() => handleDownload(template.filePath)}
                  >
                    Download
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p className="p-title">No templates uploaded yet.</p>
      )}

      <h2 className="awardapplication-title">Upload Application Criteria Details</h2>
      <label className="p-title">Please Upload a PDF Document</label>
      <Container className="mt-4">
        {criteriaMessage && <Alert variant="info">{criteriaMessage}</Alert>}

        <Form onSubmit={handleCriteriaUpload}>
          <Form.Group controlId="awardTypeCriteria" className="mt-3">
            <Form.Label>Select Award Type:</Form.Label>
            <Form.Control
              as="select"
              value={awardTypeCriteria}
              onChange={(e) => setAwardTypeCriteria(e.target.value)}
            >
              <option value="">Choose...</option>
              {awardOptions.length > 0 ? (
                awardOptions.map((award) => (
                  <option key={award.Award_Id} value={award.Award_Id}>
                    {award.Name}
                  </option>
                ))
              ) : (
                <option>No award types available</option>
              )}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="formCriteriaFile" className="mt-3">
            <Form.Label>Upload Application Criteria:</Form.Label>
            <Form.Control
              type="file"
              accept=".pdf"
              onChange={handleCriteriaFileChange}
            />
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="upload-btn-directorapplication mt-3"
          >
            Upload Criteria
          </Button>
        </Form>
      </Container>

      <h3 className="mt-5">Uploaded Criteria Details</h3>
      {criteria.length > 0 ? (
        <Table striped bordered hover className="application_table">
          <thead>
            <tr>
              <th>Award Type</th>
              <th>Criteria File</th>
              <th>View File</th>
            </tr>
          </thead>
          <tbody>
            {criteria.map((criterion, index) => (
              <tr key={index}>
                <td>{criterion.awardName}</td>
                <td>{criterion.FilePath2}</td>
                <td>
                  <Button
                    variant="success"
                    size="sm"
                    onClick={() => handleDownloadCriteria(criterion.FilePath2)}
                  >
                    Download
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p className="p-title">No criteria uploaded yet.</p>
      )}
    </div>
  );
};

export default AwardApplications;